<template>
  <div class="question">
    <template v-if="questionData">
      <p class="question__name">{{ questionData.name }}</p>
      <img @click="setPopinState" class="question__img" :src="`http://transfertsdepekin.fr/assets/places/${questionData.placeImg}`" :alt="questionData.name">
      <a @click="setPopinState" class="question__btn btn">
        <template v-if="questionData.type === 'chance'">Chance</template>
        <template v-else>Question</template>
      </a>

      <div class="question__stars">
        <img src="~@/img/star_white.png" alt="Star">
        <img src="~@/img/star_orange.png" alt="Star">
        <img src="~@/img/star_orange.png" alt="Star">
        <img src="~@/img/star_white.png" alt="Star">
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'question',
    props: [
      'params',
    ],
    data() {
      return {
        questionData: this.params,
      };
    },
    methods: {
      setPopinState() {
        this.$store.commit('setDataPopin', this.questionData);
        this.$store.commit('setShowPopin', true);
      },
    },
  };
</script>


<style lang="scss">
  .question {
    .question__name {
      color: $blue;
      text-align: center;
      text-transform: uppercase;
      @include fontSize(40);

      @include mobile {
        margin-bottom: 20px;
        @include fontSize(30);
      }
    }

    .question__img {
      display: block;
      margin: auto;
      max-width: 270px;
      cursor: pointer;

      @include large-desktop {
        max-width: 420px;
      }

      @include mobile  {
        max-width: 100%;
        max-height: 170px;
      }
    }
  }

  .question__btn {
    position: relative;
    display: block;
    margin: auto;
    top: 30px;
    width: 200px;
    text-transform: uppercase;
    @include fontSize(23);

    @include mobile {
      top: 0;
      margin-top: 30px;
      margin-bottom: 50px;
      width: 60%;
      min-width: 190px;
      @include fontSize(20);
    }
  }

  .question__btn,
  .popin-question__continue {
    color: $white;
    background: $orange;
    border-color: $orange;
    text-align: center;
    padding: 8px 15px;
    cursor: pointer;

    &:hover {
      background: $white;
      color: $orange;
    }
  }

  .popin-question__continue {
    @include fontSize(18);

    @include mobile {
      display: block;
      color: $orange;
      background: $white;
      border-color: $white;
      width: 100%;

      &:hover {
        background: $orange;
        color: $white;
      }
    }
  }

  .question__stars {
    position: absolute;
    top: 35px;
    left: 0;
    width: 135px;
    height: 100px;
    transform: translateX(-100%);

    @include mobile {
      display: none;
    }

    img {
      position: absolute;
      opacity: 0;

      @for $i from 1 through 4 {
        &:nth-child(#{$i}) {
          animation: starAppear .4s .6s + .1 * $i forwards;
        }
      }

      &:first-child,
      &:nth-child(3),
      &:nth-child(4) {
        width: 28px;
      }

      &:first-child {
        left: 0;
        bottom: 0;
      }

      &:nth-child(2) {
        top: 11px;
        right: 40px;
        width: 85px;
      }

      &:nth-child(3) {
        top: 0;
        right: 35px;
      }

      &:nth-child(4) {
        top: 25px;
        right: 0;
      }
    }
  }

  @keyframes starAppear {
    0% {
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 1;
      transform: scale(1);      
    }
  }
</style>



// WEBPACK FOOTER //
// Question.vue?9959818c